<template>
  <div>
    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centerhistory") }}</h4>
        </div>
      </div>
    </div>


    <!--content start-->
    <div>
      <div class="grab">
        <table style="width:100%">
          <tr>
            <td rowspan="2" class="history_title">2018</td>
            <td class="history_month"> 01</td>
            <td class="history_detail">대기환경연구센터 개소 </td>
          </tr>
          <tr>
            <td class="history_month history_bottom_line""> 01</td>
            <td class="history_detail history_bottom_line">1대 센터장 이강웅 교수(한국외대 환경학과) </td>
          </tr>
          <tr>
            <td rowspan="4" class="history_title"> 2019</td>
            <td class="history_month"> 01</td>
            <td class="history_detail">WISE 기상관측장비 국립기상과학원 이관 </td>
          </tr>
          <tr>
            <td class="history_month"> 01</td>
            <td class="history_detail">2대 센터장 박문수 교수(세종대) </td>
          </tr>
          <tr>
            <td class="history_month"> 08</td>
            <td class="history_detail">1차 BBMEX 수행 </td>
          </tr>
          <tr>
            <td class="history_month history_bottom_line"> 08</td>
            <td class="history_detail history_bottom_line">국립기상과학원 공동 워크숍 </td>
          </tr>
          <tr>
            <td rowspan="4" class="history_title"> 2020</td>
            <td class="history_month"> 05</td>
            <td class="history_detail">WISE 전산서버 기상산업개발원 이관 </td>
          </tr>
          <tr>
            <td class="history_month"> 08</td>
            <td class="history_detail">2차 BBMEX 수행 </td>
          </tr>
          <tr>
            <td class="history_month"> 09</td>
            <td class="history_detail">3대 센터장 지준범 교수 (연구교수) </td>
          </tr>
          <tr>
            <td class="history_month history_bottom_line"> 10</td>
            <td class="history_detail history_bottom_line">2020년 하반기 워크숍 개최  </td>
          </tr>
          <tr>
            <td rowspan="4" class="history_title"> 2021</td>
            <td class="history_month history_bottom_line"> 01</td>
            <td class="history_detail history_bottom_line">운영위원회 운영위원 변경(김영성교수 > 장유운교수)</td>
          </tr>
        </table>
      </div>
    </div>


  </div>
</template>
<style scoped>
  table tr {
    height: 48px;
    text-align: center;
    font-size: 16px
  }
  table tr th {
    background-color: #f2f2f2;
    text-align: center;
    border-bottom: 1px solid #d7d7d7;
    border-top: 1px solid #d7d7d7;
    font-size: 16px;
  }
</style>
<script>

  export default {
    name: 'CenterHistory'
  }
</script>



// WEBPACK FOOTER //
// src/components/CenterHistory.vue